import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';

const ProductReimbursableLogo = ({ logos , variant ='default'  })=>{
    const { getLabel  } = useIntl();
    if (!logos || !logos.default && !logos.alternative) {
        return null;
    }
    const logoUrl = variant === 'alternative' && logos.alternative ? logos.alternative : logos.default;
    return /*#__PURE__*/ React.createElement("div", {
        className: "product-reimbursable",
        "data-t": variant
    }, /*#__PURE__*/ React.createElement("img", {
        className: "product-reimbursable__image",
        src: logoUrl,
        alt: getLabel('products.insuranceReimbursable')
    }));
};
var ProductReimbursableLogo$1 = ProductReimbursableLogo;

export { ProductReimbursableLogo$1 as default };
//# sourceMappingURL=ProductReimbursableLogo.js.map
